// Where to go after signing in, taken from `?next=` (#358: an invite link sends
// a signed-out friend through /login and must bring them back to the invite).
//
// Only a same-site path is accepted. Anything else would make /login an open
// redirect: a link that shows our sign-in page and then forwards the user to
// someone else's site.
export function safeNext(next) {
  if (typeof next !== 'string') return null;
  if (!next.startsWith('/')) return null;          // absolute URLs, javascript:, etc.
  if (next.startsWith('//') || next.startsWith('/\\')) return null;  // protocol-relative
  return next;
}
